import { useEffect } from 'react';

import { useThemeContext } from './use-theme-context';

function useTheme(theme) {
  const { setTheme } = useThemeContext();
  useEffect(() => {
    setTheme(theme);
  }, [theme, setTheme]);
}

export { useTheme };
